import { showNotification } from '@mantine/notifications'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '..'

export const addSmsRecipient = (alertRuleId: string, phoneNumber: string) =>
  api.post(`/v1/alert-rules/${alertRuleId}/sms-recipients`, { phoneNumber })

export const useAddSmsRecipient = (alertRuleId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (phoneNumber: string) =>
      addSmsRecipient(alertRuleId, phoneNumber),
    onSuccess: () => {
      queryClient.invalidateQueries(['alertRule', alertRuleId, 'smsRecipients'])
      showNotification({
        message: 'SMS recipient added successfully',
        color: 'green',
      })
    },
    onError: () => {
      showNotification({
        message: 'Failed to add SMS recipient',
        color: 'red',
      })
    },
  })
}
